var addItemToLoader = function(loader,url)
{
    if(!loader.resources[url])
    {
        loader.add(url);
    }
};

//bool for storing if all the assets are loaded
var ccAssetsLoaded = false;
PIXI.dontSayHello = true;
var sound = null;
//pixi loading objects for preloading and regular loading

var ccPreLoader = new PIXI.loaders.Loader();
var ccLoader = new PIXI.loaders.Loader();
var ccJSONLoader = new PIXI.loaders.Loader();

ccPreLoader.add(assetsURL + "snd/audio_sprites.json");
ccLoader.add(assetsURL + "fnt/vag_rounded.fnt");
ccLoader.add(assetsURL + "fnt/vag_rounded_big.fnt");

var onPreloadComplete = function() {
    startApp();
};
var onPreloadProgress = function(loader, res) {
    if (res.data.sprite) {
        totalLoadThresholds++;
        if (navigator.userAgent.match(/Kindle|Silk/i) !== null) {
            sound = new CC.Sound({
                src: [
                    res.name.replace(".json", ".ogg")
                ],
                milliseconds: true,
                sprites: res.data.sprite
            });
        } else {
            sound = new CC.Sound({
                src: [
                    res.name.replace(".json", ".ogg"),
                    res.name.replace(".json", ".m4a"),
                    res.name.replace(".json", ".mp3"),
                    res.name.replace(".json", ".ac3")
                ],
                milliseconds: true,
                sprites: res.data.sprite
            });
        }
    }
};


var initApp = function() {
    ccJSONLoader.add("skin",assetsURL + "data/skin.json");
    ccJSONLoader.load();
};

//loaded asset count for use in load bars
totalLoadAssetsToLoad = 0;
//loaded asset count for use in load bars
ccLoadedAssetCount = 0;

//total loaded asset count for use in load bars
//ccTotalLoadedAssetCount = ccAssetArray.length;
var ccAnimationList = {};
var ccLoadedJson = {};
//called each time an asset is loaded
var onLoaderProgress = function(loader, res) {
    ccLoadedAssetCount++;
    if (res.data.skeleton) {
        var dataSpine = res.name.split("/");
        var dataName = dataSpine[dataSpine.length - 1].replace(".json", "");
        ccAnimationList[dataName] = res;
    }else if(res.xhrType ==="json")
    {
        ccLoadedJson[res.name] = res.data;
    }
};
WebFont.load({
    custom: {
        families: ['fred_burger', 'fred_burger_shadow']
    }
});
var loadThresholds = 0;
var totalLoadThresholds = 0;
var onLoaderComplete = function() {
    loadThresholds++;
    if (loadThresholds >= totalLoadThresholds) {
        startGameFunction();
    }
};

var startGameFunction = function() {
    URLQuery = window.location.href.split("?");
    var nextScreen;
    if (URLQuery.length == 2) {
        nextScreen = URLQuery[1];
    }
    if(Screens[nextScreen]){
        CC.WebApp.current.swapScreen(Screens[nextScreen]());
    }else{
        CC.WebApp.current.swapScreen(Screens.startScreen());
    }
};

var appendPathToTextures = function(obj)
{
    for (var key in obj)
    {
        if(obj.hasOwnProperty(key)){
            if (typeof obj[key] == "object" && obj[key] !== null && key != "textures"){
                appendPathToTextures(obj[key]);
            }
            else if(key == "texture" ||key == "texture_a"||key == "texture_b"){
                obj[key] = assetsURL +Screens.json.imageDirectory+ obj[key];
            }else if(key == "textures"){
                for (var i = 0; i < obj[key].length; i++) {
                    obj[key][i] = assetsURL +Screens.json.imageDirectory+ obj[key][i];
                }
            }
        }
    }
};

var addTexturesToLoader = function(loader,obj){
    for (var key in obj)
    {
        if(obj.hasOwnProperty(key)){
            if (typeof obj[key] == "object" && obj[key] !== null && key != "textures"){
                addTexturesToLoader(loader,obj[key]);
            }
            else if(key == "texture" ||key == "texture_a"||key == "texture_b"){
                addItemToLoader(loader,obj[key]);
            }else if(key == "textures"){
                for (var i = 0; i < obj[key].length; i++) {
                    addItemToLoader(loader,obj[key][i]);
                }
            }
        }
    }
};

var onJSONLoadComplete = function()
{
    Screens.json = ccLoadedJson.skin;
    appendPathToTextures(Screens.json);
    var screenJson = Screens.json.screens.loadingScreen;
    addItemToLoader(ccPreLoader, screenJson.bg.texture_a);
    addItemToLoader(ccPreLoader, screenJson.bg.texture_b);
    addItemToLoader(ccPreLoader, screenJson.bar.texture);
    addTexturesToLoader(ccLoader,Screens.json);
    ccPreLoader.load();
};


ccJSONLoader.once('complete',onJSONLoadComplete);
ccJSONLoader.on('progress',onLoaderProgress);
ccPreLoader.on('progress', onPreloadProgress);
ccPreLoader.once('complete', onPreloadComplete);
ccLoader.on('progress', onLoaderProgress);
ccLoader.once('complete', onLoaderComplete);




var canvas;
var interactiveArea = document.getElementById("interactive-area");
if (CC.isMobile) {
    setInterval(function () {
        if (!canvas && CC.WebApp.current.renderer) {
            canvas = CC.WebApp.current.renderer.view;
        }
        var forcePause;
        if (canvas) {
            var targetWindow = window.top;
            if (targetWindow.innerHeight > targetWindow.innerWidth) {
                if (canvas.style.display !== "block") {
                    interactiveArea.style.backgroundImage = "none";
                    canvas.style.display = "block";
                    forcePause = false;
                }
            } else {
                if (canvas.style.display !== "none") {
                    interactiveArea.style.backgroundImage = "url("+assetsURL+"img/rotate_screen.png)";
                    canvas.style.display = "none";
                    forcePause = true;
                }
            }
        }
    }, 100);
} else {
    interactiveArea.style.backgroundImage = "none";
}
